import { Doctor, ViewClaimResults } from 'all-in-one-shared-api';
import { isLocaleEnglish } from 'utils/languageUtils';

import { PreviousClaimProps } from '../components/PreviousClaim/PreviousClaimCard';
import { ClaimFormState } from '../schema';
import { DEFAULT_CLAIM_FORM_VALUE } from '../constants';
export class PreviousClaimUtils {
  static mapPreviousClaimToCard = (prev: ViewClaimResults, lang: string): PreviousClaimProps => {
    const isEnglish = isLocaleEnglish(lang);
    const benefitDescription = isEnglish ? prev.benefit?.description : prev.benefit?.chineseDescription;
    return {
      claimType: prev.claimType,
      title: benefitDescription || (isEnglish ? prev.claimType.description : prev.claimType.chineseDescription),
      description: isEnglish ? prev.diagnosis.description : prev.diagnosis.chineseDescription,
      doctor: isEnglish ? prev.doctor.description : prev.doctor.chineseDescription,
      treatmentDate: prev.treatmentDate,
    };
  };
  static getDoctorName = (doctor: Doctor, isEnglish: boolean) => {
    return isEnglish ? doctor.description : doctor.chineseDescription;
  };

  static mapPreviousClaimToForm = (prev: ViewClaimResults, lang: string): Partial<ClaimFormState> => {
    return {
      ...DEFAULT_CLAIM_FORM_VALUE,
      claimType: prev.claimType.code,
      doctorId: prev.doctor.code,
      doctorName: this.getDoctorName(prev.doctor, isLocaleEnglish(lang)),
      doctorNameQuery: this.getDoctorName(prev.doctor, isLocaleEnglish(lang)),
      diagnosisCode: prev.diagnosis.code,
    };
  };

  // don't know how to type query string lol
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static mapCopyClaimToForm = (copy: any): ClaimFormState => {
    return {
      ...DEFAULT_CLAIM_FORM_VALUE,
      patientMemberType: copy?.patientMemberType || '',
      claimTypeObject:
        copy?.claimTypeCode === 'OP'
          ? copy?.benefitNames?.map((o: string) => `__${o}`)
          : [copy?.claimTypeCode].filter((c) => !!c),
      doctorId: copy?.doctorId || '',
      doctorName: copy?.doctorName || '',
      doctorNameQuery: copy?.doctorName || '',
      diagnosisCode: copy?.diagnosisCode || '',
    };
  };
}
